import { Box, Typography } from "@mui/material";
import MapPhoto from "../../assets/images/bees/map.png";
import CriSection from "../../components/CriSection";

const Overview = () => {
  return (
    <CriSection>
      <Box
        sx={{
          display: "flex",
          flexDirection: {
            xs: "column",
            md: "row",
          },
        }}
      >
        <Box
          sx={{
            flexGrow: 1,
            flexBasis: 0,
          }}
        >
          <Typography
            sx={{
              fontSize: "36px",
              fontWeight: 300,
              lineHeight: 1,
            }}
          >
            Overview
          </Typography>

          <Typography
            sx={{
              fontWeight: 300,
              fontSize: "16px",
              lineHeight: 1.2,
              marginTop: "12px",
            }}
          >
            Laura Rericha-Anchor and CRI research associates Robert Jean and
            Michael Arduser continue to work on the Bees of the Southern Lake
            Michigan Region monograph, a work discussing the regional
            distributions of 523 bee species identified by the authors. The
            paper also highlights the phenologies, habitat preferences, faunal
            associations, and life histories of the region’s bees.
          </Typography>

          <Typography
            sx={{
              fontWeight: 300,
              fontSize: "16px",
              lineHeight: 1.2,
              marginTop: "12px",
              marginBottom: "12px",
            }}
          >
            The Southern Lake Michigan Region consists of 53 counties in the
            following four states: Wisconsin (SE/SC), Illinois (NE/NC), Indiana
            (NW/NC), and Michigan (SW). Observed have been numerous bee species
            that are conservative to certain natural divisions, such as the Rock
            River Hill Country in north-central Illinois and the Kettle Moraine
            Area of south-eastern Wisconsin.
          </Typography>
        </Box>

        <Box
          sx={{
            textAlign: "center",
            marginLeft: {
              xs: 0,
              md: "36px",
            },
            marginTop: {
              xs: "24px",
              md: 0,
            },
            width: {
              xs: "100%",
              md: "400px",
            },
          }}
        >
          <img
            src={MapPhoto}
            alt="Map"
            style={{
              width: "100%",
              height: "300px",
              borderRadius: "12px",
              objectFit: "cover",
            }}
          />
          <Typography
            sx={{
              marginTop: "6px",
              fontSize: "14px",
              fontWeight: 400,
            }}
          >
            Southern Lake Michigan Region
          </Typography>
        </Box>
      </Box>
    </CriSection>
  );
};

export default Overview;
